import { CampaignGroupIdSchema as _ } from "@hprofits/shared";
import { z as e } from "zod";
const R = [
  "domain",
  "sys_adunit_number",
  "ad_unit_type",
  // Exact format names (the banner size lives only in the name, e.g. "UVB Mobile (300x100)").
  "ad_unit_format",
  "traffic_source",
  // 0 = Direct, >0 = SSP id, -1 = SSP with unknown feed; any non-zero value requires SplitTrafficSourceBySsp.
  "traffic_source_id",
  "sys_country",
  "device_type_name",
  "os_type_name",
  "sys_browser_type",
  "sys_language",
  "content_type",
  "impressions"
], O = e.enum(R), ce = 0, o = e.enum(["=", "!=", "like", "eq", "neq", "<=", ">=", "replace"]), r = e.object({
  key: O,
  condition: o,
  values: e.array(e.union([e.string(), e.number()]))
}).refine((t) => t.key !== "traffic_source_id" || t.values.every((n) => Number.isInteger(n)), {
  message: "traffic_source_id values must be integers",
  path: ["values"]
}).readonly(), M = e.enum(["impressions"]), I = e.object({
  key: M,
  direction: e.enum(["asc", "desc"])
}).readonly(), ie = e.object({
  filters: e.array(r).default([]),
  order: e.array(I).default([]),
  limit: e.number().int().positive().optional(),
  offset: e.number().int().nonnegative().optional()
}).readonly(), y = 100, S = e.enum(["domain", "spot"]), me = e.discriminatedUnion("mode", [
  e.object({
    mode: e.literal(S.enum.domain),
    keys: e.array(e.string().min(1)).max(y),
    filters: e.array(r).default([])
  }),
  e.object({
    mode: e.literal(S.enum.spot),
    keys: e.array(e.int()).max(y),
    filters: e.array(r).default([])
  })
]).readonly(), x = e.object({
  key: e.string(),
  // Row count of the matching expansion endpoint (its metadata.total), not children.length.
  total: e.int().nonnegative(),
  children: e.array(e.string()).readonly()
}).readonly(), de = e.object({
  items: e.array(x).readonly()
}).readonly(), v = e.enum([...R, "sys_campaign_number"]), A = e.enum(["impressions", "date"]), k = e.object({
  key: v,
  condition: o,
  values: e.array(e.union([e.string(), e.number()]))
}).readonly(), G = e.object({
  key: A,
  direction: e.enum(["asc", "desc"])
}).readonly(), ue = e.object({
  code: e.string(),
  from: e.string(),
  to: e.string(),
  groups: e.array(e.string()),
  metrics: e.array(e.string()),
  filters: e.array(k).default([]),
  order: e.array(G).default([]),
  metrics_macro: e.string().optional(),
  limit: e.number().int().positive().optional(),
  offset: e.number().int().nonnegative().optional()
}).readonly(), N = e.object({
  title: e.string(),
  tag: e.string().optional()
}).readonly(), q = e.union([e.string(), N]), b = e.object({
  dimensions: e.record(e.string(), q),
  metrics: e.record(e.string(), e.number()),
  keys: e.record(e.string(), e.unknown())
}).readonly(), s = e.object({
  limit: e.number(),
  offset: e.number(),
  count: e.number(),
  total: e.number()
}).readonly(), ye = e.object({
  stats: e.array(b),
  totals: e.record(e.string(), e.number()),
  querySql: e.array(e.string()).optional(),
  metadata: s
}).readonly(), D = 2, h = 64, U = e.enum(["day", "weekHourly", "week", "month"]), c = e.enum([
  "common_advert_report_new",
  "common_advert_admin_report_new"
]), Se = e.object({
  campaignId: _,
  period: U,
  metrics: e.array(e.string().trim().min(1).max(h)).min(1).max(D),
  reportCode: c
}).readonly(), P = e.object({
  keys: e.record(e.string(), e.string()),
  metrics: e.record(e.string(), e.number())
}).readonly(), le = e.object({
  stats: e.array(P)
}).readonly(), pe = e.object({
  reportCode: c
}).readonly(), Q = e.object({
  key: e.string(),
  name: e.string(),
  description: e.string(),
  /** Display format: `integer`, `money`, `percent` (ae-stat may add others). */
  valueType: e.string(),
  /** `sum` for an additive metric; anything else is a rate the server computes for the total. */
  valueTotal: e.string()
}).readonly(), ge = e.object({
  metrics: e.array(Q)
}).readonly(), X = 100, l = 366, L = 864e5, p = (t, n) => (Date.parse(n) - Date.parse(t)) / L, _e = e.object({
  campaignId: _,
  reportCode: c,
  from: e.iso.date(),
  to: e.iso.date(),
  metrics: e.array(e.string().trim().min(1).max(h)).min(1).max(X)
}).refine(({ from: t, to: n }) => p(t, n) >= 0, { error: "from must not be after to", path: ["to"] }).refine(({ from: t, to: n }) => p(t, n) <= l, {
  error: `the range must not exceed ${l} days`,
  path: ["from"]
}).readonly(), F = e.object({
  ruleId: e.string(),
  metrics: e.record(e.string(), e.number())
}).readonly(), Re = e.object({
  rows: e.array(F)
}).readonly(), w = 128, Y = 200, f = 100, i = 1e3, K = 5, m = 4, H = 200, V = 500, a = e.string().trim().min(1).max(w), B = e.object({
  code: e.string(),
  name: e.string(),
  categoryCode: e.string(),
  defaultMetrics: e.array(e.string())
}).readonly(), be = e.object({
  reports: e.array(B)
}).readonly(), he = e.object({
  reportCode: a
}).readonly(), $ = e.object({
  key: e.string(),
  name: e.string()
}).readonly(), fe = e.object({
  dimensions: e.array($)
}).readonly(), z = e.object({
  key: a,
  condition: o,
  values: e.array(e.union([e.string(), e.number()])).max(i)
}).readonly(), Z = e.object({
  key: a,
  direction: e.enum(["asc", "desc"])
}).readonly(), j = e.object({
  reportCode: a,
  from: e.iso.datetime(),
  to: e.iso.datetime(),
  filters: e.array(z).max(f).default([]),
  limit: e.int().positive().max(V),
  offset: e.int().nonnegative().default(0)
}), je = j.extend({
  groups: e.array(a).min(1).max(m),
  metrics: e.array(a).min(1).max(H),
  order: e.array(Z).max(K).default([])
}).refine(({ from: t, to: n }) => Date.parse(t) <= Date.parse(n), { error: "from must not be after to", path: ["to"] }).readonly(), Ce = e.object({
  stats: e.array(b),
  totals: e.record(e.string(), e.number()),
  metadata: s
}).readonly(), Te = j.extend({
  dimension: a,
  search: e.string().trim().max(Y).optional()
}).refine(({ from: t, to: n }) => Date.parse(t) <= Date.parse(n), { error: "from must not be after to", path: ["to"] }).readonly(), J = e.object({
  id: e.union([e.string(), e.number()]),
  name: e.string()
}).readonly(), Ee = e.object({
  values: e.array(J),
  metadata: s
}).readonly(), g = 100, W = /^[a-f0-9]{32}$/, C = e.string().regex(W), T = e.object({
  reportCode: a,
  from: e.iso.date(),
  to: e.iso.date(),
  groups: e.array(a).max(m),
  dimensions: e.record(
    a,
    e.object({
      values: e.array(e.union([e.string(), e.number()])).min(1).max(i),
      include: e.boolean()
    }).readonly()
  ).refine((t) => Object.keys(t).length <= g),
  metrics: e.record(a, e.object({ min: e.number().nullable(), max: e.number().nullable() }).readonly()).refine((t) => Object.keys(t).length <= g)
}).readonly(), Oe = e.object({ state: T }).readonly(), Me = e.object({ queryId: C }).readonly(), Ie = e.object({ queryId: C }).readonly(), xe = e.object({ state: T }).readonly(), ee = 255, d = e.coerce.number().int().positive(), te = e.object({
  key: a,
  name: e.string()
}).readonly(), ae = e.object({
  id: e.union([e.string(), e.number()]),
  name: e.string()
}).readonly(), ne = e.object({
  name: e.string(),
  include: e.boolean(),
  values: e.array(ae).min(1).max(i)
}).readonly(), u = e.object({
  name: e.string().trim().min(1).max(ee),
  reportCode: a,
  groups: e.array(te).max(m),
  dimensions: e.record(a, ne).refine((t) => Object.keys(t).length <= f)
}), re = u.readonly(), E = u.extend({ id: d }).readonly(), ve = e.object({ segments: e.array(E) }).readonly(), Ae = re, ke = u.extend({
  segmentId: d
}).readonly(), Ge = e.object({ segmentId: d }).readonly(), Ne = e.object({ segment: E }).readonly();
export {
  _e as CampaignRollupRequestSchema,
  Re as CampaignRollupResponseSchema,
  F as CampaignRollupRowSchema,
  U as CampaignTimeseriesPeriodSchema,
  c as CampaignTimeseriesReportCodeSchema,
  Se as CampaignTimeseriesRequestSchema,
  le as CampaignTimeseriesResponseSchema,
  P as CampaignTimeseriesRowSchema,
  ce as DIRECT_TRAFFIC_SOURCE_ID,
  N as DimensionNameObjectSchema,
  q as DimensionNameSchema,
  y as MAX_CHILD_COUNTS_KEYS,
  m as MAX_REPORT_GROUP_COUNT,
  H as MAX_REPORT_METRIC_COUNT,
  V as MAX_REPORT_PAGE_SIZE,
  X as MAX_ROLLUP_METRIC_COUNT,
  l as MAX_ROLLUP_RANGE_DAYS,
  D as MAX_TIMESERIES_METRIC_COUNT,
  s as MetadataSchema,
  ie as StatBusinessRequestSchema,
  x as StatChildCountsItemSchema,
  S as StatChildCountsModeSchema,
  me as StatChildCountsRequestSchema,
  de as StatChildCountsResponseSchema,
  b as StatGroupSchema,
  v as StatGroupedFilterKeySchema,
  k as StatGroupedFilterSchema,
  A as StatGroupedOrderKeySchema,
  G as StatGroupedOrderSchema,
  ue as StatGroupedRequestSchema,
  ye as StatGroupedResponseSchema,
  o as StatQueryFilterConditionSchema,
  O as StatQueryFilterKeySchema,
  r as StatQueryFilterSchema,
  Ie as StatQueryGetRequestSchema,
  xe as StatQueryGetResponseSchema,
  C as StatQueryIdSchema,
  M as StatQueryOrderKeySchema,
  I as StatQueryOrderSchema,
  Oe as StatQuerySaveRequestSchema,
  Me as StatQuerySaveResponseSchema,
  T as StatQueryStateSchema,
  $ as StatReportDimensionSchema,
  fe as StatReportDimensionsResponseSchema,
  z as StatReportFilterSchema,
  je as StatReportGroupedRequestSchema,
  Ce as StatReportGroupedResponseSchema,
  a as StatReportKeySchema,
  Z as StatReportOrderSchema,
  he as StatReportRequestSchema,
  B as StatReportSchema,
  J as StatReportValueSchema,
  Te as StatReportValuesRequestSchema,
  Ee as StatReportValuesResponseSchema,
  be as StatReportsResponseSchema,
  Ae as StatSegmentCreateRequestSchema,
  Ge as StatSegmentDeleteRequestSchema,
  ne as StatSegmentDimensionSchema,
  te as StatSegmentGroupSchema,
  d as StatSegmentIdSchema,
  re as StatSegmentInputSchema,
  Ne as StatSegmentResponseSchema,
  E as StatSegmentSchema,
  ke as StatSegmentUpdateRequestSchema,
  ae as StatSegmentValueSchema,
  ve as StatSegmentsResponseSchema,
  Q as StatisticsMetricSchema,
  pe as StatisticsMetricsRequestSchema,
  ge as StatisticsMetricsResponseSchema
};
//# sourceMappingURL=schemas.js.map
